import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar.js";
import { tokens, success, alert, toFixed, GET, POST, format_date, getStorage, roundToTwo, calculate_water, cal_water_bill, loading } from "../components/CustomComponent.js";
import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import excel_file from "../assets/files/import_bill_water.xlsx";

export default class Import extends Component {
  state = {
    import: null, currentSheet: null, over: false, data_import: null,
    type: "", common_expenses_type: 0, cable_cost: 0, common_expenses: 0,
    equipment_maintenance_fee: 0, waste_cost: 0, add_debt: 0, reduce_debt: 0,
    setting_water_id: getStorage("water_id"), water_charge_start: 0, water_charge_end: 0,
    water_charge_price: 0, water_rate_list: [], visible: false, fire_cost: 0,
    data_customer: [],
  };

  componentDidMount() {
    loading(false); // ปิด Loading ทันทีที่เข้าหน้าจอ
    this.GetSetting();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { visible } = this.state;
    if (window.pageYOffset > 300 && !visible) this.setState({ visible: true });
    else if (window.pageYOffset <= 300 && visible) this.setState({ visible: false });
  };

  scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  GetSetting = async () => {
    loading(true);
    let result = await GET(tokens, `v1/TH/water-manage/detail/${this.state.setting_water_id}`, null);
    if (result?.status) {
      let d = result.data.data;
      this.setState({
        water_charge_start: Number(d.water_charge.water_charge_start), water_charge_end: Number(d.water_charge.water_charge_end),
        water_charge_price: toFixed(Number(d.water_charge.water_charge_price)), water_rate_list: d.water_rate_list, water_calculate_type: Number(d.water_calculate_type) || 2,
        cable_cost: d.cable_cost, common_expenses_type: d.common_expenses_type, common_expenses: d.common_expenses,
        equipment_maintenance_fee: d.equipment_maintenance_fee, waste_cost: d.waste_cost, add_debt: d.add_debt, reduce_debt: d.reduce_debt,
        fire_cost: d.fire_month && format_date(new Date(), "m") === d.fire_month ? Number(d.fire_cost) : 0,
      }, () => {
        if (d.common_expenses_type) this.GetCustomerAll();
      });
    }
    loading(false);
  };

  GetCustomerAll = async () => {
    let result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) this.setState({ data_customer: result.data.data });
  };

  Create_Import = async () => {
    loading(true);
    let payload = { import_water: this.state.data_import.map(item => ({ ...item, date_of_note: item.date_of_note ? format_date(item.date_of_note, "yyyy-mm-dd", "en") : null })) };
    let result = await POST(tokens, `v1/TH/import-file/import-water/${getStorage("project_id")}`, payload);
    if (result?.status) {
      let cal = await calculate_water(this.state.address_number?.value || "");
      if (cal) success();
    }
    loading(false);
  };

  handleFile = (file) => {
    readFile(file).then((readedData) => {
      if (readedData.SheetNames[0] === "การแจ้งหนี้และจัดเก็บค่าน้ำ") {
        this.setState({ import: readedData }, () => setTimeout(this.Import, 10));
      } else alert("info", "แจ้งเตือน", "ไฟล์ไม่ถูกต้อง");
    }).catch(console.error);
  };

  Import_file = (e) => {
    if (e.target.files[0]) this.handleFile(e.target.files[0]);
    e.target.value = "";
  };

  drop_file = (e) => {
    e.preventDefault();
    this.setState({ over: false });
    const file = e.dataTransfer.items[0]?.getAsFile();
    if (file) this.handleFile(file);
  };

  cal_water = (unit_used) => cal_water_bill(unit_used, this.state);

  Import = () => {
    let array_check = ["บ้านเลขที่", "ชื่อ-นามสกุล", "วันที่จด", "วันที่", "เลขมาตรเดือนนี้", "เลขมาตรเดือนก่อน", "หน่วยที่ใช้", "รายได้อื่น ๆ", "เพิ่มหนี้", "หมายเหตุเพิ่มหนี้", "ลดหนี้", "หมายเหตุลดหนี้", "ค่าเคเบิล", "ค่าประกันอัคคีภัย"];
    let headerRow = this.state.currentSheet["การแจ้งหนี้และจัดเก็บค่าน้ำ"][0];
    
    for (let i = 0; i < array_check.length; i++) {
      if (headerRow[i] !== array_check[i]) {
        alert("warning", "แจ้งเตือน", `หัวคอลัมน์ "${array_check[i]}" ไม่ถูกต้อง`);
        return;
      }
    }

    // สร้าง Map เพื่อความเร็วระดับ O(1) แทนการใช้ .find() ในลูป
    const custMap = new Map(this.state.data_customer.map(c => [c.address_number, c]));

    const data = generateObjects(this.state.currentSheet).filter((item) => item["บ้านเลขที่"] !== "").map((item) => {
      let address = item["บ้านเลขที่"]?.toString()?.trim() || "";
      let unit = Number(item["เลขมาตรเดือนนี้"]) - Number(item["เลขมาตรเดือนก่อน"]);
      let wb = this.cal_water(unit);
      
      let ad = item["เพิ่มหนี้"] || 0, rd = item["ลดหนี้"] || 0;
      let cust = custMap.get(address);
      let ce = !this.state.common_expenses_type ? this.state.common_expenses : roundToTwo((cust?.room_size || 0) * this.state.common_expenses);
      
      let cc = roundToTwo(Number(item["ค่าเคเบิล"] || 0)), fc = roundToTwo(Number(item["ค่าประกันอัคคีภัย"] || 0)), other = Number(item["รายได้อื่น ๆ"] || 0);
      let total_amount = Number(wb) + this.state.equipment_maintenance_fee + ce + this.state.waste_cost + cc + fc + Number(ad) - Number(rd) + other;

      return {
        address_number: address, full_name: item["ชื่อ-นามสกุล"]?.toString()?.trim() || "",
        date_of_note: item["วันที่"] ? format_date(item["วันที่"], "yyyy-mm-dd", "en") : null,
        current_gauge_number: item["เลขมาตรเดือนนี้"] ? Number(item["เลขมาตรเดือนนี้"]) : 0,
        last_gauge_number: item["เลขมาตรเดือนก่อน"] ? Number(item["เลขมาตรเดือนก่อน"]) : 0,
        unit_used: unit,
        water_bill: wb, equipment_maintenance_fee: this.state.equipment_maintenance_fee,
        common_expenses: ce, waste_cost: this.state.waste_cost, cable_cost: cc,
        other_income: other, fire_cost: fc, add_debt: Number(ad), reduce_debt: Number(rd),
        remark_add_debt: item["หมายเหตุเพิ่มหนี้"], remark_reduce_debt: item["หมายเหตุลดหนี้"], total_amount,
      };
    });

    if (data.length && data[0].full_name === "ตัวอย่าง ข้อมูล") data.shift();
    this.setState({ data_import: data });
  };

  render() {
    const { data_import, over, import: importData, visible } = this.state;
    const tdL = (val) => <td className={val ? "text-left" : "text-left bg-danger-light"}>{val || "-"}</td>;
    const numFmt = (val) => <td className="text-left">{val ? toFixed(val) : "0.00"}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            <div className="w-100 d-flex justify-content-between mb-3">
              <h4 className="mb-3"><b>นำเข้าไฟล์ข้อมูล : การแจ้งหนี้และจัดเก็บค่าน้ำ</b></h4>
              <div className="d-flex">
                <button className="btn btn-outline-primary wpx-150 mx-1" onClick={() => window.location.href = "/import"}><span className="icon-brand mr-2">{"\uf060"}</span>ย้อนกลับ</button>
                {data_import && <button className="btn btn-danger wpx-150 mx-1" onClick={() => this.setState({ data_import: null })}>ล้างค่า</button>}
                {data_import && <button className="btn btn-primary wpx-150 mx-1" onClick={this.Create_Import}>นำเข้า</button>}
              </div>
            </div>

            {!data_import && (
              <div className="card border-0 p-3 mb-3">
                <div className="w-100 text-right">
                  <a className="text-primary mt-3" href={excel_file} download="import_bill_water.xlsx"><label className="icon">{"\uf65b"}</label> template นำเข้าข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ</a>
                </div>
                <div className={`card py-5 border-dashed align-items-center ${over ? "bg-blue-sky" : "bg-light"}`}
                  onDrop={this.drop_file} onDragOver={(e) => { e.preventDefault(); this.setState({ over: true }); }} onDragLeave={(e) => { e.preventDefault(); this.setState({ over: false }); }}>
                  <b className="icon text-primary mt-4" style={{ fontSize: 48 }}>{"\uf56f"}</b>
                  <b className="text-secondary">ลากและวางไฟล์ที่นี่</b>
                  <small className="text-secondary mb-3">หรือ</small>
                  <button className="btn btn-primary wpx-120 mb-4" onClick={() => document.getElementById("file").click()}>เลือกไฟล์</button>
                  <input className="d-none" type="file" id="file" accept=".xls,.xlsx" onChange={this.Import_file} />
                </div>
              </div>
            )}

            {data_import && (
              <div className="card border-0 mb-3">
                <div className="card-header bg-dark-blue px-3 rounded-top"><h4 className="mb-0 text-white"><b>ข้อมูลนำเข้า</b></h4></div>
                <div className="p-3">
                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th>บ้านเลขที่</th><th>ชื่อ-นามสกุล</th><th>วันที่จด</th><th>เลขมาตรเดือนนี้</th><th>เลขมาตรเดือนก่อน</th><th>หน่วยที่ใช้</th>
                          <th>ค่าน้ำประปา</th><th>ค่ารักษาอุปกรณ์</th><th>ค่าใช้จ่ายส่วนกลาง</th><th>ค่าขยะ</th><th>ค่าเคเบิล</th><th>ค่าประกันอัคคีภัย</th>
                          <th>รายได้อื่น ๆ</th><th>เพิ่มหนี้</th><th>หมายเหตุเพิ่มหนี้</th><th>ลดหนี้</th><th>หมายเหตุลดหนี้</th><th>รวมเป็นเงิน</th><th>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data_import.map((item, index) => (
                          <tr key={index}>
                            {tdL(item.address_number)}
                            <td className="text-left">{item.full_name || "-"}</td>
                            <td className={item.date_of_note ? "text-left" : "text-left bg-danger-light"}>{item.date_of_note ? format_date(item.date_of_note, "dd/mm/yyyy") : "-"}</td>
                            <td className="text-left">{item.current_gauge_number || "0"}</td><td className="text-left">{item.last_gauge_number || "0"}</td><td className="text-left">{item.unit_used || "0"}</td>
                            {numFmt(item.water_bill)}{numFmt(item.equipment_maintenance_fee)}{numFmt(item.common_expenses)}{numFmt(item.waste_cost)}{numFmt(item.cable_cost)}
                            {numFmt(item.fire_cost)}{numFmt(item.other_income)}{numFmt(item.add_debt)}
                            <td className="text-left">{item.remark_add_debt || "-"}</td>
                            {numFmt(item.reduce_debt)}
                            <td className="text-left">{item.remark_reduce_debt || "-"}</td>
                            {numFmt(item.total_amount)}
                            <td>
                              <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0 pointer" onClick={() => {
                                  let dt = [...data_import]; dt.splice(index, 1);
                                  this.setState({ data_import: dt.length ? dt : null });
                                }}>
                                <span className="icon text-danger">{"\uf2ed"}</span>
                              </label>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            <div className="d-none"><ReactExcel initialData={importData} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" /></div>
          </div>
        </div>
        {visible && <button className="position-fixed btn btn-primary" onClick={this.scrollToTop} style={{ bottom: 30, right: 30, zIndex: 100 }}>กดเพื่อไปยังด้านบน</button>}
      </div>
    );
  }
}